import { FC } from 'react';
import classNames from 'classnames';

import { RenderStatus } from 'services/finalcut.service';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { IntroKeys } from 'components/app/intro/intro-keys';
import { useClipsSwitch } from 'components/app/_hooks/use-clips-switch';
import { useFinalcutCb } from 'components/app/finalcuts/_mediator/use-finalcut-cb';
import { setFcPlayback } from 'components/app/finalcuts/_mediator/fc-controls.slice';

import { AppButton } from 'components/app/app-components/app-button/app-button';
import styles from './_finalcuts-controls.module.scss';

interface Props {
  className?: string;
}

export const FinalcutsControls: FC<Props> = ({ className }) => {
  const { fcSeekToStart, fcSeekToEnd } = useFinalcutCb();
  const { handleNextClip, handlePrevClip } = useClipsSwitch();
  const fcPlayback = useAppSelector((state) => state.fc__controls.fcPlayback);
  const fcStatus = useAppSelector((state) => state.fc__data.fcStatus);
  const dispatch = useAppDispatch();

  return (
    <div className={classNames(styles.FinalcutsControls, className)}>
      <AppButton outlined onClick={fcSeekToStart} tip="Seek to start of final cut track" tipPosition="top">
        {'<'} Start
      </AppButton>
      <AppButton outlined onClick={fcSeekToEnd} tip="Seek to end of final cut track" tipPosition="top">
        {'>'} End
      </AppButton>
      <div className={styles.playPauseBtn}>
        <AppButton
          onClick={() => dispatch(setFcPlayback())}
          disabled={fcStatus !== RenderStatus.rendered}
          data-intro={IntroKeys.fcPlay}
          tip={
            fcStatus !== RenderStatus.rendered
              ? 'Final cut is not rendered'
              : fcPlayback
              ? 'Pause playback'
              : 'Play final cut'
          }
          tipPosition="bottom"
        >
          {fcPlayback ? 'Pause' : 'Play'}
        </AppButton>
      </div>
      <AppButton outlined onClick={handlePrevClip} tip="Navigate to previous clip" tipPosition="bottom">
        {'<'} Clip
      </AppButton>
      <AppButton outlined onClick={handleNextClip} tip="Navigate to next clip" tipPosition="bottom">
        {'>'} Clip
      </AppButton>
    </div>
  );
};
